import { Stack, Typography } from '@mui/material';
import React from 'react';

import { GitBranchIcon } from '@/shared/assets/icons/git-branch-icon';
import { Tooltip } from '@/shared/components/ui/tooltip/tooltip';
import { TVersionLabelProps } from '@/shared/components/ui/version-label/version-label.types';
import { formatVersionId } from '@/shared/utils/format';

export const VersionLabel: React.FC<TVersionLabelProps> = ({
  versionMetadata,
  variant = 'primary',
}) => {
  if (!versionMetadata?.versionId) {
    return null;
  }

  return (
    <Stack direction="row" gap="0.375rem" alignItems="center">
      <GitBranchIcon variant={variant === 'primary' ? 'primary' : 'light'} />
      <Tooltip title={versionMetadata?.versionId} placement="top" arrow>
        <Typography
          variant="p9"
          color={variant === 'primary' ? 'primary' : 'textContrast'}
        >
          {formatVersionId(versionMetadata)}
        </Typography>
      </Tooltip>
    </Stack>
  );
};
